import PropTypes from 'prop-types';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { etiColors } from '@eti/styles';
import {
  ALL,
  SOME,
  NONE,
  TRAIN_EQUIPMENT_CODE,
  BUS_EQUIPMENT_CODE,
} from '../../../constants/transportationMeansConstants';
import {
  PlusIcon,
  planeIconUpStyles,
  SegmentLabel,
  TravelModeInfo,
  TravelModeText,
} from './styles/tripDetailsSegment';

const TripDetailsSegmentLabel = ({
  brandedFareName,
  cabinClassName,
  equipmentCode,
  includesTrainSegments,
  isExpanded,
}) => {
  const { t } = useTranslation();

  return (
    <SegmentLabel>
      {!isExpanded && includesTrainSegments === SOME && (
        <TravelModeInfo data-testid="tripDetails-segment-mixed">
          <Icon
            className={planeIconUpStyles}
            color={etiColors.grayScale[10]}
            id="plane-bold"
            size="12px"
          />
          <PlusIcon> + </PlusIcon>
          <Icon color={etiColors.grayScale[10]} id="train" size="12px" />
        </TravelModeInfo>
      )}
      {!isExpanded && includesTrainSegments === ALL && (
        <TravelModeInfo data-testid="tripDetails-segment-train">
          <Icon color={etiColors.grayScale[10]} id="train" size="12px" />
          <TravelModeText data-testid="tripDetails-bound-train-text">
            {t('IbeClient.Segment.Train.Text')}
          </TravelModeText>
        </TravelModeInfo>
      )}
      {!isExpanded && includesTrainSegments === NONE && (
        <TravelModeInfo data-testid="tripDetails-segment-cabinClass">
          <Icon
            className={planeIconUpStyles}
            color={etiColors.grayScale[10]}
            id="plane-bold"
            size="12px"
          />
          <TravelModeText data-testid="tripDetails-bound-plane-text">
            {brandedFareName || t(`IbeClient.CabinClass.${cabinClassName}.Text`)}
          </TravelModeText>
        </TravelModeInfo>
      )}
      {isExpanded && equipmentCode === TRAIN_EQUIPMENT_CODE && (
        <TravelModeInfo data-testid="tripDetails-segment-train">
          <Icon color={etiColors.grayScale[10]} id="train" size="12px" />
          <TravelModeText data-testid="tripDetails-bound-train-text">
            {t('IbeClient.Segment.Train.Text')}
          </TravelModeText>
        </TravelModeInfo>
      )}
      {isExpanded && equipmentCode === BUS_EQUIPMENT_CODE && (
        <TravelModeInfo data-testid="tripDetails-segment-bus">
          <Icon color={etiColors.grayScale[10]} id="bus" size="12px" />
          <TravelModeText data-testid="tripDetails-bound-bus-text">
            {t('IbeClient.Segment.Bus.Text')}
          </TravelModeText>
        </TravelModeInfo>
      )}
      {isExpanded &&
        equipmentCode !== TRAIN_EQUIPMENT_CODE &&
        equipmentCode !== BUS_EQUIPMENT_CODE && (
          <TravelModeInfo data-testid="tripDetails-segment-cabinClass">
            <Icon
              className={planeIconUpStyles}
              color={etiColors.grayScale[10]}
              id="plane-bold"
              size="12px"
            />
            <TravelModeText data-testid="tripDetails-bound-plane-text">
              {brandedFareName || t(`IbeClient.CabinClass.${cabinClassName}.Text`)}
            </TravelModeText>
          </TravelModeInfo>
        )}
    </SegmentLabel>
  );
};

TripDetailsSegmentLabel.propTypes = {
  brandedFareName: PropTypes.string,
  cabinClassName: PropTypes.string,
  equipmentCode: PropTypes.string,
  includesTrainSegments: PropTypes.oneOf(['ALL', 'SOME', 'NONE']),
  isExpanded: PropTypes.bool,
};

export default TripDetailsSegmentLabel;
